import { FC, useContext } from 'react';
import { get, partition, xor } from 'lodash';
import { CbMultiSelect } from '../CbMultiSelect';
import CloseCircle from '../Icons/CloseCircle';
import { TableContext } from './';
import styles from './MultiWithBadges.module.css';
import filterStyles from './AllFiltersDrawer.module.css';
type ChangeHandler = (newSelectedArray: string[]) => void;
interface DateRangeFilterProps {
  allSelectedValues: string[];
  columnId?: string;
  onChange: ChangeHandler;
}
const PLACEHOLDER = 'Select...';
export const MultiWithBadges: FC<DateRangeFilterProps> = ({
  allSelectedValues,
  columnId,
  onChange
}) => {
  const {
    filterInfo
  } = useContext(TableContext);
  const filter = filterInfo.find(filter => filter.columnId === columnId) as any;
  const allOptions = get(filter, 'filterConfig.options', []) as any[];
  const [selectedOptions, unselectedOptions] = partition(allOptions, ({
    value
  }) => allSelectedValues.includes(value));
  const formattedOptions = unselectedOptions.map(option => ({
    label: option.label,
    value: option.value
  }));
  const handleChange = selectedValues => {
    onChange(xor(allSelectedValues, selectedValues.map(({
      value
    }) => value)));
  };
  const optionSelected = selectedOptions.length > 0;
  return <div className={filterStyles.filterComponent} data-sentry-component="MultiWithBadges" data-sentry-source-file="MultiWithBadges.tsx">
      <span className={filterStyles.filterLabel}>{filter.columnName}</span>
      <CbMultiSelect className={filterStyles.filterSelect} onChange={handleChange} options={formattedOptions} placeholder={PLACEHOLDER} value={PLACEHOLDER} data-sentry-element="CbMultiSelect" data-sentry-source-file="MultiWithBadges.tsx" data-sentry-element="CbMultiSelect" />
      {optionSelected && <div className={styles.badgeContainer}>
          {selectedOptions.map(({
        label,
        value
      }) => {
        const handleClose = () => onChange(xor(allSelectedValues, [value]));
        return <div className={styles.closeableBadge}>
                <CloseCircle className={styles.closeIcon} onClick={handleClose} />
                <span className={styles.badgeText}>{label}</span>
              </div>;
      })}
        </div>}
    </div>;
};